import { useParams } from 'react-router-dom'

export const useParamAsInteger = (name: string) => {
  const params = useParams()

  const paramValue = params[name]

  return !!paramValue ? parseInt(paramValue) : undefined
}
